import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8wjy8j74ag: FaireBrandEntity = {
  token: "b_8wjy8j74ag",
  type: "brand",
  name: "Mauve Jewelry Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/3ed6d5b9fe74f4faab560f751e88e0302bfc1ac047bbf8a6f9baa2dadba84650.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3097ae81ef440e32573e3d0ac5396f135d33900e8b896da4d28c822ca8ad3405.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3ed6d5b9fe74f4faab560f751e88e0302bfc1ac047bbf8a6f9baa2dadba84650.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3097ae81ef440e32573e3d0ac5396f135d33900e8b896da4d28c822ca8ad3405.jpeg",
  location: "Salt Lake City, UT, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 104,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Mauve Jewelry Co! We specialize in jewelry that is elegant yet unique, and carries meaning in each piece. Your new favorite every day jewelry that adds the perfect accent, no matter the occasion.\n\nFounded with love out of Salt Lake City, Utah.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:05.402Z",
    importedBy: "entity-db-cli",
  },
};
